import { appConfig as $config } from '../../app.config';
import { UI } from '../UI';
import { Common } from '../Common';
import { App } from '../App';
import { User } from '../User';
import { ValidationRules } from '../ValidationRules';
import { ColorVariants } from '../ColorVariants';
import { MockupCompare } from '../MockupCompare';
import { DistributionChannels } from '../DistributionChannels';
import { DistributionTerritories } from '../DistributionTerritories';
import { addFileDialog } from './addFileDialog';
import { copyStoreDialog } from './copyStoreDialog';
import { Trims } from '../../pages/Trims';
import { DataTableColumns } from './constants';

import './scss/masterproductdata.scss';

import ReactDOM from 'react-dom';
import React from 'react';
import ColorgateConfigurationModal from '../../../../../../client/features/ColorgateConfigurationModal/index';

export const MasterProductData = (function () {
  let lastQuery;
  let id;
  let $isLicensor = '';
  let $initialFormData = {};

  let mapping = {
    data: (data, defaults = []) => {
      data.masterProductData.availableLangPacks = data.masterProductData.availableLangPacks || [];

      data.masterProductData.licensor =
        data.masterProductData.licensor ||
        data.masterProductData?.originalFiles?.find((f) => !!f?.asset?.licensor)?.asset?.licensor;

      if (!data.masterProductData.defaultLangCode) {
        data.masterProductData.defaultLangCode = 'En';
      }

      if (data.masterProductData.availableLangPacks.length === 0) {
        data.masterProductData.availableLangPacks.push({
          languageCode: data.masterProductData.defaultLangCode,
          moduleType: 0,
          propertyValues: []
        });
      }

      let autoAddingLangs = ['En', 'Fr', 'De', 'It', 'Es'];
      data.masterProductData.availableLangPacks.forEach((e) => {
        autoAddingLangs = _.reject(autoAddingLangs, (re) => {
          return re == e.languageCode;
        });
      });

      autoAddingLangs.forEach((e) => {
        data.masterProductData.availableLangPacks.push({ languageCode: e, moduleType: 0, propertyValues: [] });
      });

      // Master raw data
      data.masterProductData.masterRawData = {
        productName: data.masterProductData.productName,
        productDescription: data.masterProductData.productDescription,
        bulletPoints: [...(data.masterProductData.bulletPoints || [])],
        tags: [...(data.masterProductData.tags || [])],
      };

      let languages = defaults.find((lang) => lang.key == 'Languages');
      data.masterProductData.storesWithLanguages.forEach((item) => {
        item.languages = [];
        data.masterProductData.availableLangPacks.forEach((langPack) => {
          let lang = languages.values.find((val) => val.Item1 == langPack.languageCode);
          if (lang) {
            let checkLang = item.languageCodes.find((f) => f == langPack.languageCode);
            item.languages.push({ code: langPack.languageCode, checked: checkLang != undefined, codeName: lang.Item2 });
          }
        });

        if (!item.productName) {
          item.productName = data.masterProductData.productName;
          item.productDescription = data.masterProductData.productDescription;
          item.bulletPoints = [...(data.masterProductData.bulletPoints || [])];
          item.tags = [...(data.masterProductData.tags || [])];
        }
      });

      data.masterProductData.availableSizesWithCheckbox = [];
      data.availableSizes.forEach((s) => {
        data.masterProductData.availableSizesWithCheckbox.push({ size: s.size, checked: s.select });
      });

      let colorVariants = [];
      $.each(data.blank.variants, function (k, v) {
        let files = _.findWhere(data.blank.variants, { color: v.color }).files;
        colorVariants.push({
          color: v.color,
          colorHex: v.colorHex,
          uri:
            files && files.length && files[0].uri
              ? files[0].uri
              : v.blankVariantAreas && v.blankVariantAreas.length && v.blankVariantAreas[0].file.uri
              ? v.blankVariantAreas[0].file.uri
              : false
        });
      });

      data.blank.colorVariants = colorVariants;
      data.blank.availableSizes = data.blank.availableSizes.join(', ');

      // Hex Colors in Commerce details
      data.masterProductData.commerce.details.forEach((det) => {
        det.colorHex = _.find(data.blank.variants, (item) => {
          return item.color.toUpperCase() == det.color.toUpperCase();
        }).colorHex;
      });

      // Comparing Items
      data.compares = MockupCompare.mapping.data(data.masterProductData.productDetails);

      // Currency Symbol for display
      data.masterProductData.commerce.defaultPrice.currencySymbol = Common.currencySymbolByCode(
        data.masterProductData.commerce.defaultPrice.currencyCode
      );

      return {
        ...data
      };
    },
    defaults: (data, prelisting) => {
      let newArr = {};
      $.each(data, function (k, v) {
        newArr[v.key] = v.values;
      });
      //Languages
      newArr.avaibaleLang = [];
      newArr.currentForCheckLang = [];
      let mpdLocales = window['mpdlocale'] || [];
      $.each(newArr.Languages, function (k, v) {
        let availableLang = _.filter(prelisting.masterProductData.availableLangPacks, (item) => {
          return item.languageCode.toUpperCase() == v.Item1.toUpperCase();
        });
        if (availableLang && availableLang.length > 0) {
          if (v.Item1.toUpperCase() == prelisting.masterProductData.defaultLangCode.toUpperCase()) {
            newArr.currentLangCode = v.Item1;
          }
          newArr.avaibaleLang.push(v);
        } else {
          newArr.currentForCheckLang.push(v);
        }
      });
      newArr.Currencies.forEach((curr) => {
        curr.currencySymbol = Common.currencySymbolByCode(curr.Item1);
      });
      return newArr;
    },
    territories: (data) => {
      let cont = [];
      $.each(data, (k, v) => {
        if (v.Item1 != 'Worldwide') {
          cont.push({ idx: v.Item1.replace(' ', '').toLowerCase(), name: v.Item1, countries: v.Item2 });
        }
      });
      return cont;
    },
    productionData: (data) => {
      let firstRows = data.masterProductData.artworkForProductionItems;
      firstRows.forEach((el) => {
        el.checked = false;
        el.isHidden = false;

        el.canvasSizeWidth = Common.inchToCm(el.canvasSizeWidth);
        el.canvasSizeHeight = Common.inchToCm(el.canvasSizeHeight);
        el.canvasLocation = Common.inchToCm(el.canvasLocation);

        let decodedFilename = decodeURI(el.file.fileName);
        let lastDotIndex = decodedFilename.lastIndexOf('.');
        let fileName = decodedFilename.substring(0, lastDotIndex);
        let decodedFilenames = decodedFilename.split('.');
        el.file.fileName =
          fileName +
          ' ' +
          el.sizeRange +
          '_' +
          el.canvasSizeWidth +
          '_' +
          el.canvasSizeHeight +
          '.' +
          decodedFilenames[decodedFilenames.length - 1];
      });
      let secondRows = data.masterProductData.addTrims;
      secondRows = secondRows.map((m) => ({
        trim: m,
        checked: false,
        isCustom: false
      }));

      let removedTrims = data.masterProductData.removedTrims || [];

      let availebleTrimTypes = secondRows.filter((e) => e.trim.trimType).map((e) => e.trim.trimType);

      let sideIndexes = {
        Front: 0,
        Back: 1,
        RightSleeve: 2,
        LeftSleeve: 3,
      };

      let assetVersionAssignmentsTable = (data.masterProductData.assetVersionAssignments || []).reduce(
        (acc, assetVersion) => {
          if (assetVersion.isHidden) {
            return acc;
          }

          assetVersion.versions.some((v) => {
            if (v.colorGroup + v.name === assetVersion.version.colorGroup + assetVersion.version.name) {
              v.selected = true;
              return true;
            }
          });

          if (typeof sideIndexes[assetVersion.side] === 'undefined') {
            return acc;
          }

          const colorRow = acc.find((c) => c.color === assetVersion.color);

          if (!colorRow) {
            const row = {
              color: assetVersion.color,
              sides: [{ side: 'Front' }, { side: 'Back' }, { side: 'RightSleeve' }, { side: 'LeftSleeve' }]
            };

            row.sides[sideIndexes[assetVersion.side] || 0] = assetVersion;
            acc.push(row);
          } else {
            colorRow.sides[sideIndexes[assetVersion.side] || 0] = assetVersion;
          }

          return acc;
        },
        []
      );

      let productionDataTabModel = {
        FirstTableRows: firstRows,
        filter: { size: 'None', areaType: 'None' },
        filterTrim: 'None',
        firstTableUpdateFlag: 0,
        SecondTableRows: secondRows,
        assetVersionAssignmentsTable: assetVersionAssignmentsTable,
        assetVersionAssignments: data.masterProductData.assetVersionAssignments || [],
        removedTrims: removedTrims,
        secondTableAdditionalRow: {
          trim: '',
          isCustom: true,
          checked: false
        },
        secondTableTrimUploadedFlag: 0,
        secondTableUpdateFlag: 0,
        availebleTrimTypes: availebleTrimTypes
      };
      return productionDataTabModel;
    }
  };

  let init = (id, accountId, lastQuery = {}, providerCode) => {
    lastQuery = lastQuery;
    id = id;
    UI.block('#page');

    let productiontabIndex = document.location.search.indexOf('tab=production');

    $isLicensor = User.isLicensor();

    window['beforemasterproductlastquery'] = lastQuery;
    let url = `MasterProductData/${accountId}/${id}`;
    url = providerCode ? `${url}/${providerCode}` : url;
    $.when(App.ajaxData(url, {})).done((res) => {
      let prelisting = mapping.data(res.object, res.defaults);
      if (res.defaults) {
        prelisting.defaults = mapping.defaults(res.defaults, prelisting);
      }
      prelisting.masterProductData.standartId = prelisting.standartId;

      let productionDataTab = mapping.productionData(prelisting);

      let pageData = {
        ...{
          backpagename: lastQuery && lastQuery.pagename ? lastQuery.pagename : $lang.MasterProductData.PreListings,
          backpagelink:
            (lastQuery && lastQuery.pageurl ? lastQuery.pageurl : '/prelistings') +
            (lastQuery ? (lastQuery.query ? '?' + lastQuery.query : '') : ''),
          referer: lastQuery.referer ? lastQuery.referer : false,
          $lang: $lang,
          data: prelisting,
          mpd_currenteditedcontent: prelisting,
          productionDataTab: productionDataTab,
          mpdlocale: window['mpdlocale']['en'] || [],
          apiUrl: $config.apiURL,
          productiontab: productiontabIndex > -1,
          isLicensor: $isLicensor,
        }
      };
      App.pageData('productionDataTab', productionDataTab);

      let template = require('./tmpl/masterProductData.hbs');
      UI.page(template, pageData).then(() => {
        App.pageData('mpd_currenteditedcontent', prelisting);
        App.pageData('mpdlocale', pageData.mpdlocale);
        App.pageData('productionDataTab', productionDataTab);

        pageinit(pageData.data);
      });

      if (productiontabIndex > -1) {
        let queryParam = document.location.search.substring(productiontabIndex, 0);
        if (queryParam && queryParam.substring(queryParam.length - 1) == '&') {
          queryParam = queryParam.substring(queryParam.length - 1, 0);
        }
        history.replaceState(null, '', `${document.location.pathname}${queryParam ? '?' + queryParam : ''}`);
      }
    });
  };

  let pageinit = (pageData) => {
    //** COPY STORE BUTTON
    $('.js-copyStore-dialog').on('click', () => {
      productFormSubmit(null, copyStoreDialog.run);
    });

    $('.js-action-editCGconfig').on('click', (e) => {
      e.preventDefault();
      const { color, size, sku, imageFileUrl } = $(e.target.parentNode).data('rowData');
      const {
        accountId,
        id,
        blank: { brand, title, brandCode }
      } = App.pageData('data');
      const url = `${$config.apiURL}/prelistings/colorgate-configuration/${accountId}?ProductId=${id}&Color=${color}&Size=${size}`;

      const onClose = () =>
        ReactDOM.unmountComponentAtNode(document.getElementById('colorgate-configuration-dialog-container'));

      const onSave = (values) => {
        const changedData = values ? values.object : {};
        $.ajax({
          type: 'post',
          url: url,
          data: JSON.stringify(changedData),
          dataType: 'json',
          contentType: 'application/json',
          complete: function (data) {
            //TODO: hide loader, handle error
            ReactDOM.unmountComponentAtNode(document.getElementById('colorgate-configuration-dialog-container'));
          }
        });
      };

      //TODO: show loader, handle error
      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (res) {
          const data = {
            description: {
              name: `${brand} - ${title} - ${brandCode}`,
              imageFileUrl,
              color,
              size,
              sku
            },
            formData: res
          };
          ReactDOM.render(
            React.createElement(ColorgateConfigurationModal, {
              data,
              onSave,
              onClose
            }),
            document.getElementById('colorgate-configuration-dialog-container')
          );
        }
      });
    });

    KTApp.initScroll();

    let $form = $('#MasterProductDataForm');

    $('.action-edit-territories', $form).on('click', editTerritoriesDialog);

    $('.action-edit-distChanel', $form).on('click', editDistChanelDialog);

    $('.action-generate-models-mockups', $form).on('click',  () => {
        UI.blockPage();

        const {
          accountId,
          id
        } = App.pageData('data');

        $.when(App.ajaxData(`/masterProductData/generate-silhouettes/${accountId}/${id}`, {}, 'POST'))
        .done((res) => {
          UI.unblockPage();
          if (!res.isSuccess) {
            return UI.errorMessage(res.errorInformation.errorReason);
          }

          UI.notify({
            text: $lang.alert.SuccessfullyStartedGenerateModelsMockups,
            icon: 'fal fa-check-circle',
            type: 'success'
          });
        });
    });

    $($form)
      .off()
      .on('click', '.js-action-addMockupFile', addMockupFile)
      .on('click', '.js-action-downloadMockupfile', downloadMockupFile)
      .on('click', '.js-action-removeMockupFile', removeMockupFile);

    $('[name="defaultPriceCurrencyCode"]', $form).select2({
      placeholder: $lang.MasterProductData.ChooseCurrency
    });

    // Tags input - Select2
    $('[name="meta"]')
      .select2({
        placeholder: 'Add a tag',
        tags: true,
        tokenSeparators: [',']
      })
      .on('change', Common.select2focus);

    $('.mpd-select2-control').select2();

    /** -- Sizes Variants*/
    $('input.size-checkbox-item', $form).on('change', onSizesChanged);

    /** -- ColorVariants*/
    ColorVariants.init('#mpd-colors', pageData);
    let availableColors = App.pageData('mpd_currenteditedcontent.masterProductData.availableColors');
    $.each($('.item-color-checkbox'), (index, color) => {
      $(color).removeAttr('disabled');
      $(color)[0].checked = availableColors.includes($(color)[0].name);
      $(color).change(function () {
        onColorChanged($(this));
      });
    });

    $('#downloadImageForAllFormat', $form).on('click', downloadImageForAllFormat);

    if (pageData.masterProductData.tags) {
      pageData.masterProductData.tags.forEach((val) => {
        let newOption = new Option(val, val, false, true);
        $('[name="meta"]', $form).append(newOption);
      });
    }

    $('.js-product-cancel').on('click', (e) => {
      UI.offPageLeaveHandler();
      lastQuery = window['beforemasterproductlastquery'];
      delete window['beforemasterproductlastquery'];
      $router.push(
        `${lastQuery && lastQuery.pageurl ? lastQuery.pageurl : '/prelistings'}${
          lastQuery ? (lastQuery.query ? '?' + lastQuery.query : '') : ''
        }`
      );
    });
    $('.js-product-save').on('click', productFormSubmit);

    $('.js-translate').on('click', () => {
      let formData = generateFormData();
      if (JSON.stringify($initialFormData) === JSON.stringify(formData)) {
        productTranslate();
        return;
      }

      productFormSubmit(null, () => productTranslate());
    });

    $('.js-generate').on('click', () => {
      let productDataRequest = getDataForSave(true);

      const EntityType = location.pathname.split('/')[1] === 'prelistings' ? 'Prelistings' : 'Listings';

      UI.blockPage();

      $.when(App.ajaxData(`${EntityType.toLowerCase()}/generateContent`, {
        EntityType,
        Entity: productDataRequest
      }, 'POST'))
        .done((res) => {
          if (!res.isSuccess) {
            return validationErrorMessage(res);
          }

          let currenteditedcontent = App.pageData('mpd_currenteditedcontent');

          const tags = typeof res.object.keywords[0] === 'string' ?
            res.object.keywords :
            res.object.keywords.reduce((acc, k) => acc.concat(k.Keywords));

          const updatedData = {
            productDescription: res.object.description,
            bulletPoints: res.object.bulletPoints,
            tags: tags,
            productName: res.object.title,
          };

          currenteditedcontent.masterProductData.storesWithLanguages?.forEach((store) =>
            Object.assign(store, updatedData)
          );

          App.pageData('mpd_currenteditedcontent', currenteditedcontent);

          initCurrentStore();
        })
        .always(() => {
          UI.unblockPage();
        });
    });

    // Image popup
    $('.magnific-image').magnificPopup({ type: 'image' });

    $('.js-action-versionswitcher')
      .select2({
        templateResult: formatVersions,
        templateSelection: formatVersions
      })
      .on('select2:select', (e) => {
        const value = $(e.target).val();
        const color = $(e.target).attr('data-color');
        const side = $(e.target).attr('data-side');

        const assetVersionAssignments = App.pageData('productionDataTab.assetVersionAssignments');
        const currentAssetVersion = assetVersionAssignments.find(av => av.color === color && av.side === side);

        if (!currentAssetVersion) {
          return;
        }

        const currentVersion = currentAssetVersion.versions.find(v => v.name === value);
        if (!currentVersion) {
          return;
        }

        currentAssetVersion.version = currentVersion;

        App.pageData('productionDataTab.assetVersionAssignments', assetVersionAssignments);
      });

    $('.js-action-storeswitcher')
      .select2({
        templateResult: storeFormatVersions,
        templateSelection: storeFormatVersions
      })
      .on('select2:select', (e) => {
        // saveLangPack();
        saveStore();

        App.pageData('mpd_currenteditedcontent.defaults.currentStore', $(e.target).val());

        // initCurrentLang();
        initCurrentStore();
      });

    originalFilesInit();

    productionDataTab.pageinit();

    $initialFormData = generateFormData();

    UI.unblock('#page');
  };

  const formatVersions = (opt) => {
    const value = $(opt.element).val();
    const text = $(opt.element).text();
    const src = $(opt.element).attr('data-src');

    if (!value) {
      return false;
    }

    if (value === '-1') {
      return $(`<div class="select2-version-option select2-version-option-new">
        <i class="fal fa-plus-square"></i> ${text}
      </div>`);
    }

    return $(`<div class="select2-version-option">
      <div style="background-image:url('${src}')"></div>
      ${text}</div>`);
  };

  const storeFormatVersions = (opt) => {
    const value = $(opt.element).val();
    const text = $(opt.element).text();

    if (!value) {
      return false;
    }

    return $(`<div class="select2-version-option">${text}</div>`);
  };

  let addMockupFile = (e) => {
    e.preventDefault();
    let target = $(e.target).is('a') ? $(e.target) : $(e.target).closest('a');
    let areatype = target.attr('areatype');
    let MPD = App.pageData('mpd_currenteditedcontent.masterProductData');
    let productDetails = App.pageData('mpd_currenteditedcontent.masterProductData.productDetails');

    let sharedData = {};

    addFileDialog.mockup({
      data: {
        mpd: MPD,
        element: _.findWhere(productDetails, { areaType: areatype }),
        $lang: $lang
      },
      ok: (data) => {
        checkUniqueComparisonMockups(data, productDetails, areatype, sharedData)
          .then(() => isMainStoreImageOverridingNeeded(data, productDetails, areatype, sharedData))
          .then(() => addMockupFileCallback(data, productDetails, areatype))
          .then(() => {
            addFileDialog.close();
            sharedData = {};
          })
          .catch(() => {
            if (sharedData.mainImage) {
              sharedData.mainImage.isMainImage = true;
            }

            if (sharedData.existingComparison) {
              sharedData.existingComparison.isHidden = false;
            }
          });
      }
    });
  };

  let isMainStoreImageOverridingNeeded = (data, productDetails, areatype, sharedData) => {
    if (!data.isMainImage) {
      return Promise.resolve();
    }

    let arr = _.findWhere(productDetails, { areaType: areatype });
    let mainImage = _.findWhere(arr.areaDetails, { isMainImage: true });
    if (!mainImage) {
      return Promise.resolve();
    }

    if (mainImage.isHidden) {
      mainImage.isMainImage = false;
      return Promise.resolve();
    }

    const img = mainImage.imageFileUrl || mainImage.fileSrc;

    return overwriteWarningMessage(
      '<i class="far fa-fw fa-exclamation-triangle text-danger font-weight-light mr-10"></i>You are about to overwrite the main store image',
      `The existing main store image is: <a href="#" style="background-image: url(${img})"
      class="magnific-image table-thumbnail kt-ml-50 kt-mr-10 mockup-files-areaType"></a> Mockup
      <br>If you decide to continue, the selection of main store image will be replaced.`
    )
      .then(() => {
        mainImage.isMainImage = false;
        sharedData.mainImage = mainImage;
      });
  };

  let checkUniqueComparisonMockups = (data, productDetails, areatype, sharedData) => {
    if (data.externalFileType !== 1) {
      return Promise.resolve();
    }

    let arr = _.findWhere(productDetails, { areaType: areatype });
    let existingComparison = _.findWhere(arr.areaDetails, { externalFileType: 1, isHidden: false });

    if (!existingComparison) {
      return Promise.resolve();
    }

    return overwriteWarningMessage(
      '<i class="far fa-fw fa-exclamation-triangle text-danger font-weight-light mr-10"></i></i>You are about to overwrite the comparison mockup image',
      'There is already a comparison mockup image for this panel.<br> If you decide to continue, the existing comparison mockup image will be replaced.'
    )
      .then(() => {
        existingComparison.isHidden = true;
        sharedData.existingComparison = existingComparison;
      });
  };

  let addMockupFileCallback = (data, productDetails, areatype) => {
    let arr = _.findWhere(productDetails, { areaType: areatype });
    arr.areaDetails.push(data);
    arr.isHidden = false;

    // Set to compare
    App.pageData('mpd_currenteditedcontent.compares', MockupCompare.mapping.data(productDetails));

    App.pageData('mpd_currenteditedcontent.masterProductData.productDetails', productDetails);
    // Image popup
    //setTimeout(()=>{ $('.magnific-image.table-thumbnail').magnificPopup({ type: 'image' }); }, 100);
  };

  let overwriteWarningMessage = (title = '', message = '') => {
    return new Promise((resolve, reject) => {
      bootbox.dialog({
        title: title,
        message: `<span class="text-body my-4">${message}</span>`,
        size: 'large',
        className: 'deletemessage-dialog-modal overwrite-warning',
        onEscape: () => {
          return reject('User close');
        },
        buttons: {
          Ok: {
            label: 'Continue & Overwrite',
            className: 'btn btn-danger bbw-border-radius',
            callback: function (e) {
              return resolve(true);
            }
          },
          Cancel: {
            className: 'btn btn-link',
            callback: function () {
              return reject('User close');
            }
          }
        }
      });
    });
  };

  let downloadMockupFile = (e) => {
    const target = $(e.target).hasClass('js-action-downloadMockupfile')
      ? $(e.target)
      : $(e.target).closest('.js-action-downloadMockupfile');
    const filesurl = target.data('fileurl');
    if (!filesurl) return;
    downloadUrls(filesurl.split(','));
  };

  let removeMockupFile = (e) => {
    e.preventDefault();
    let target = $(e.target).is('a') ? $(e.target) : $(e.target).closest('a');
    let data = target.data();
    let productDetails = App.pageData('mpd_currenteditedcontent.masterProductData.productDetails');
    productDetails[data.areaIdx].areaDetails[data.areaDetailIdx].isHidden = true;

    // Set to compare
    App.pageData('mpd_currenteditedcontent.compares', MockupCompare.mapping.data(productDetails));
    // Set new data
    App.pageData('mpd_currenteditedcontent.masterProductData.productDetails', productDetails);
  };

  let addPrintFile = (e) => {
    let MPD = App.pageData('mpd_currenteditedcontent.masterProductData');
    addFileDialog.printfile({
      data: {
        mpd: MPD,
        element: App.pageData('productionDataTab.FirstTableRows'),
        $lang: $lang
      },
      ok: (data) => {
        let lastDotIndex = data.file.fileName.lastIndexOf('.');
        let fileName = data.file.fileName.substring(0, lastDotIndex);
        let fileNames = data.file.fileName.split('.');
        data.file.fileName = `${fileName} ${data.sizeRange}_${data.canvasSizeWidth}_${data.canvasSizeHeight}.${
          fileNames[fileNames.length - 1]
        }`;

        window['DT'].productionDataTab.FirstTableRows.push(data);
        App.pageData(
          'mpd_currenteditedcontent.masterProductData.artworkForProductionItems',
          App.pageData('productionDataTab.FirstTableRows')
        );
      }
    });
  };

  let generateFormData = () => {
    let $form = $('#MasterProductDataForm');
    let formData = $form.serializeObject();

    let commerce = {
      DefaultPrice: App.pageData('mpd_currenteditedcontent.masterProductData.commerce.defaultPrice'),
      DefaultWholePrice: App.pageData('mpd_currenteditedcontent.masterProductData.commerce.defaultWholePrice'),
      LicensorsPrice: {
        CurrencyCode: formData.licensorsPriceCurrencyCode,
        CurrencyValue: formData.licensorsPriceCurrencyValue
      },
      ApprovalNumber: formData.approvalNumber,
      LicensorRoyalty: formData.licensorRoyalty,
      LicenseeRoyalty: formData.licenseeRoyalty,
      AgentRoyalty: formData.agentRoyalty,
      Details: App.pageData('mpd_currenteditedcontent.masterProductData.commerce.details'),
      ColorPrices: []
    };

    let wrapPrices = $('#price-wrap .wrap-list');
    for (let i = 0; i < wrapPrices.length; i++) {
      let element = $(wrapPrices[i]);
      let color = element.find('[name=colors]').val();
      let currencyCode = element.find('[name=currencyCode]').val();
      let currencyValue = element.find('[name=currencyValue]').val();
      commerce.ColorPrices.push({ Color: color, Price: { CurrencyCode: currencyCode, CurrencyValue: currencyValue } });
    }

    let availableSizes = [];
    let sizeCheckboxes = $('.size-checkbox-item');
    for (let i = 0; i < sizeCheckboxes.length; i++) {
      let element = $(sizeCheckboxes[i]);
      if (element[0].checked) {
        availableSizes.push(element.val());
      }
    }

    var keywords = [];
    let keywordWrap = $('[name="keyword"]');
    for (let i = 0; i < keywordWrap.length; i++) {
      let element = $(keywordWrap[i]);
      keywords.push(element.val());
    }

    let storesWithLanguages = [];
    let storesWith = App.pageData('mpd_currenteditedcontent.masterProductData.storesWithLanguages');
    storesWith.forEach((item) => {
      let langCode = [];
      item.languages.forEach((lang) => {
        if (lang.checked) {
          langCode.push(lang.code);
        }
      });
      storesWithLanguages.push({
        store: item.store,
        storeDisplayName: item.storeDisplayName,
        LanguageCodes: langCode,
        productName: item.productName,
        productDescription: item.productDescription,
        bulletPoints: item.bulletPoints,
        tags: item.tags,
      });
    });

    let seconds = App.pageData('productionDataTab.SecondTableRows');
    let trims = [];
    seconds.forEach((item) => {
      if (item.isCustom) {
        trims.push(item.trim);
      }
    });

    let afpFiles = App.pageData('mpd_currenteditedcontent.masterProductData.artworkForProductionItems');

    afpFiles.forEach((item) => {
      item.canvasSizeWidth = Common.cmToInch(item.canvasSizeWidth);
      item.canvasSizeHeight = Common.cmToInch(item.canvasSizeHeight);
    });

    formData = {
      ...formData,
      ...{
        tags: formData.meta ? (Array.isArray(formData.meta) ? formData.meta : [formData.meta]) : [],
        commerce: commerce,
        distributionTerritories: formData.distributionTerritories.split(';'),
        storesWithLanguages: storesWithLanguages,
        bulletPoints: App.pageData('mpd_currenteditedcontent.masterProductData.bulletPoints'),
        Keywords: keywords,
        artworkForProductionItems: afpFiles,
        removedTrims: App.pageData('productionDataTab.removedTrims'),
        productDetails: App.pageData('mpd_currenteditedcontent.masterProductData.productDetails'),
        originalFiles: App.pageData('mpd_currenteditedcontent.masterProductData.originalFiles'),
        availableSizes: availableSizes,
        availableColors: App.pageData('mpd_currenteditedcontent.masterProductData.availableColors'),
        defaultLangCode: App.pageData('mpd_currenteditedcontent.masterProductData.defaultLangCode'),
        addTrims: trims,
        assetVersionAssignments: App.pageData('productionDataTab.assetVersionAssignments')
      }
    };

    return formData;
  };

  let formIsValid = (form, formData) => {
    let isValid = true,
      isValidSku = true;

    // Default Price Validation
    if (
      formData.commerce.DefaultPrice.currencyValue <= 0 &&
      !$(`[name='defaultPriceCurrencyValue']:visible`).first().length
    ) {
      UI.notify({
        text: $lang.MasterProductData.Errors.DefaultPriceIsRequiredAtStoreData,
        icon: 'fal fa-times-circle',
        type: 'danger'
      });
      return false;
    }

    // Price Validation
    formData.commerce.Details.forEach((item, index) => {
      if (
        item.price.currencyValue <= 0 &&
        DT.mpd_currenteditedcontent.masterProductData.commerce.details[index].isHidden === false
      ) {
        isValid = false;
      }
    });

    if (!isValid) {
      if ($(`#colorAndPriceWrap .border-danger:visible`).first().length) {
        UI.scrollToElement('#colorAndPriceWrap .border-danger');
        UI.notify({
          text: $lang.MasterProductData.Errors.PriceIsRequired,
          icon: 'fal fa-times-circle',
          type: 'danger'
        });
      } else {
        UI.notify({
          text: $lang.MasterProductData.Errors.PriceIsRequiredAtStoreData,
          icon: 'fal fa-times-circle',
          type: 'danger'
        });
      }


      return false;
    }

    // SKU Number Validation
    $('.js-action-commerce-sku:visible').each(function () {
      let elem = $(this);
      if (elem.val() == '') {
        elem.addClass('border-danger');
        isValidSku = false;
      }
    });
    if (!isValidSku) {
      UI.scrollToElement('.js-action-commerce-sku.border-danger');
      UI.notify({
        text: $lang.MasterProductData.Errors.SKUIsRequired,
        icon: 'fal fa-times-circle',
        type: 'danger'
      });
      return false;
    }

    form.validate({ rules: ValidationRules.mpdForm, messages: ValidationRules.mpdFormMessage });

    if (!form.valid()) {
      UI.scrollToElement('.is-invalid');
      isValid = false;
    }

    return isValid;
  };

  let getDataForSave = (ignoreInvalidForm = false) => {
    saveStore();

    let $form = $('#MasterProductDataForm');
    let formData = generateFormData();
    if (!formIsValid($form, formData) && !ignoreInvalidForm) {
      return false;
    }

    // saveLangPack(formData);

    let masterProductData = App.pageData('mpd_currenteditedcontent.masterProductData');
    Object.assign(formData, masterProductData.masterRawData);

    // Filter undefined lang packs
    let availableLangPacks = App.pageData('mpd_currenteditedcontent.masterProductData.availableLangPacks');
    App.pageData(
      'mpd_currenteditedcontent.masterProductData.availableLangPacks',
      availableLangPacks.filter((lp) => lp.languageCode != undefined)
    );
    let avaibaleLang = App.pageData('mpd_currenteditedcontent.defaults.avaibaleLang');
    let avaibaleLangPack = [];
    for (let i = 0; i < avaibaleLang.length; i++) {
      let availableLangs = _.filter(availableLangPacks, (item) => {
        return item.languageCode.toUpperCase() == avaibaleLang[i].Item1.toUpperCase();
      });
      if (availableLangs && availableLangs.length > 0) {
        avaibaleLangPack.push(availableLangs[0]);
      }
    }

    return { ProductData: formData, LanguagePacks: [] /*avaibaleLangPack*/ };
  };

  let productFormSubmit = (e, callback) => {
    let productDataRequest = getDataForSave();

    if (!productDataRequest) {
      return false;
    }

    UI.blockPage();

    let url = `MasterProductData/saveProductData/`;
    $.when(App.ajaxData(url, productDataRequest, 'POST')) //Getting Brands list
      .done((res) => {
        UI.unblockPage();

        if (!res.isSuccess) {
          return validationErrorMessage(res);
        }

        if (callback) {
          callback();
          return;
        }
        UI.offPageLeaveHandler();
        lastQuery = window['beforemasterproductlastquery'];
        delete window['beforemasterproductlastquery'];
        $router.push(
          `${lastQuery && lastQuery.pageurl ? lastQuery.pageurl : '/prelistings'}${
            lastQuery ? (lastQuery.query ? '?' + lastQuery.query : '') : ''
          }`
        );

        UI.notify({
          text: $lang.alert.SuccessfullySaved,
          icon: 'fal fa-check-circle',
          type: 'success'
        });
      })
      .always((error) => {
        if (!callback) {
          UI.unblockPage();
        }
      });
  };

  let validationErrorMessage = (res) => {
    if (res.validationErrors) {
      if (res.validationErrors.length && res.validationErrors[0].errorType == 5) {
        return UI.errorMultiMessage(res.validationErrors[0].details);
      }

      let template = require('@Pages/Artworks/edit/tmpl/validationDialog.hbs');
      bootbox.dialog({
        size: 'medium',
        title: 'Error message',
        value: null,
        message: template(res.validationErrors),
        buttons: {
          cancel: {
            label: $lang.btn.gotIt,
            className: 'btn btn-hover-dark bbw-border-radius btn-primary'
          }
        }
      });
      UI.unblock('#page');
      return UI.unblock('.modal-content');
    } else {
      return UI.errorMessage(res.errorInformation.errorReason);
    }
  };

  let productTranslate = () => {
    UI.blockPage();

    const { accountId, id } = App.pageData('data');

    $.when(App.ajaxData(`/masterProductData/translate/${accountId}/${id}`, {}, 'POST'))
      .done((res) => {
        if (res.isSuccess) {
          document.location.reload();
          return;
        }

        // show error dialog
      })
      .always(() => UI.unblockPage());
  };

  let productionDataTab = {
    mapping: {
      pageData: (pageData) => {
        let firstRows = pageData.data.masterProductData.artworkForProductionItems;
        firstRows.forEach((el) => {
          el.checked = false;
          el.file.fileName = decodeURI(el.file.fileName);
        });
        let secondRows = pageData.data.masterProductData.addTrims;
        // secondRows.forEach(e => {
        //   e.checked = false
        // });

        secondRows = secondRows.map((m) => ({
          trim: m,
          checked: false,
          isCustom: false
        }));

        let removedTrims = pageData.data.masterProductData.removedTrims;

        let availebleTrimTypes = secondRows.filter((e) => e.trim.trimType).map((e) => e.trim.trimType);
        let productionDataTabModel = {
          FirstTableRows: firstRows,
          filter: { size: 'None', areaType: 'None' },
          filterTrim: 'None',
          firstTableUpdateFlag: 0,
          SecondTableRows: secondRows,
          assetVersionAssignmentsTable: [],
          removedTrims: removedTrims,
          secondTableAdditionalRow: {
            trim: '',
            isCustom: true,
            checked: false
          },
          secondTableTrimUploadedFlag: 0,
          secondTableUpdateFlag: 0,
          availebleTrimTypes: availebleTrimTypes
        };
        pageData.productionDataTab = productionDataTabModel;
        return pageData;
      }
    },

    init: function (pageData) {
      return this.mapping.pageData(pageData);
    },

    pageinit: () => {
      let $form = $('#MasterProductDataForm');

      $('.form-control-select2').select2({ minimumResultsForSearch: 100 });

      $('.downloadJpgButton').on('click', (e) => {
        let url = $(e.target).data('image-url');
        let width = $(e.target).data('image-width');
        let height = $(e.target).data('image-height');
        let areaType = $(e.target).data('image-areaType');
        let fileName = $(e.target).data('image-fileName');

        if (url && width && height && areaType != undefined && fileName) {
          downloadProdFile([{ url: url, width: width, height: height, areaType: areaType, fileName: fileName }]);
        }
      });

      $('.js-action-addPrintFile', $form).on('click', addPrintFile);

      $('#downloadMultipleProductionArtwork').on('click', (e) => {
        let checkedRows = DT.productionDataTab.FirstTableRows.filter((o) => o.checked);
        if (checkedRows.length == 0) {
          return;
        }
        let fileUris = $.map(checkedRows, (o) => {
          return {
            url: o.file.uri,
            width: o.canvasSizeWidth,
            height: o.canvasSizeHeight,
            areaType: o.areaType,
            fileName: o.file.fileName
          };
        });

        downloadProdFile(fileUris);
        //querySelected('ProductionFileRow', fileUris);
      });

      // Trims
      $('#downloadMultipleTrimImages').on('click', (e) => {
        let checkedRows = DT.productionDataTab.SecondTableRows.filter((o) => o.checked);
        if (checkedRows.length == 0) {
          return;
        }
        let fileUris = Array.from(
          new Set(checkedRows.filter((o) => o.trim.files[1].uri).map((o) => o.trim.files[1].uri))
        );
        if (fileUris.length > 0) {
          querySelected('Trims', fileUris);
        }
      });

      $('#addNewTrimButton').on('click', () => {
        App.pageData('selectTrimAndStampModal', false);
        registerGlobalEvent();
        let parms = {
          action: 'dialog',
          typeModal: 'trims',
          trimsonly: true,
          callback: () => {
            let trim = App.pageData('selectTrimAndStampModal') || false;
            if (trim) {
              let rows = App.pageData('productionDataTab.SecondTableRows') || [];
              rows.push({ trim: trim, checked: false, isCustom: true });
              App.pageData('productionDataTab.SecondTableRows', rows);
            }
          }
        };
        Trims.init(parms);
      });

      let registerGlobalEvent = () => {
        UI.block('#MasterProductDataForm');
        $('*').on('shown.bs.modal', unblockModal);
      };

      let unblockModal = () => {
        $('*').off('shown.bs.modal');
        UI.unblock('#MasterProductDataForm');
      };

      let querySelected = (folderName, fileUris) => {
        // UI.block('#MasterProductDataForm');
        let url = `${$config.apiURL}/MasterProductData/downloadSelectedImages/${folderName}/?`;
        fileUris.forEach((val, index, list) => {
          let append = index != list.length - 1 ? '&' : '';
          url += 'selectedImageUris=' + encodeURIComponent(val) + append;
        });
        var a = document.createElement('a');
        a.href = url;
        a.download = true;
        a.click();
      };
    }
  };

  let editTerritoriesDialog = (e) => {
    e.preventDefault();

    DistributionTerritories.dialog({
      // Territories dialog data
      data: {
        continents: mapping.territories(DT.mpd_currenteditedcontent.defaults.DistributionTerritories),
        selected: DT.mpd_currenteditedcontent.masterProductData.distributionTerritories,
        $lang: $lang
      },
      // setTerritories
      ok: () => {
        let $form = $('#territoriesDialog'),
          newArr = [];
        if ($('[name="regions"]:checked', $form).val() == 'Specific') {
          $('input[type="checkbox"].js-region:checked', $form).each(function () {
            newArr.push($(this).prop('name'));
          });
        } else {
          newArr = ['Worldwide'];
        }
        if (newArr.length) window.DT.mpd_currenteditedcontent.masterProductData.distributionTerritories = newArr;
      },
      init: () => {
        UI.unblock('#page');
      }
    });
  };

  let editDistChanelDialog = (e) => {
    e.preventDefault();
    //let MPD = App.pageData('mpd_currenteditedcontent');

    let storesWithLanguages = App.pageData('mpd_currenteditedcontent.masterProductData.storesWithLanguages');
    let availableLangPacks = App.pageData('mpd_currenteditedcontent.masterProductData.availableLangPacks');
    let Languages = App.pageData('mpd_currenteditedcontent.defaults.Languages');
    let skuColumnNames = App.pageData('mpd_currenteditedcontent.masterProductData.skuColumnNames');

    let stores = [];
    storesWithLanguages.forEach((i) =>
      stores.push({ item1: i.store, item2: i.storeDisplayName, skuColumnName: i.skuColumnName })
    );
    App.pageData('selectDistChannels', stores);

    DistributionChannels.dialog({
      data: {
        element: App.pageData('mpd_currenteditedcontent.defaults.AvailableDistributionChannels'),
        $lang: $lang
      },
      accountId: App.pageData('data.accountId'),
      ok: () => {
        stores = App.pageData('selectDistChannels');
        let languages = [];
        let stwl = [];

        availableLangPacks.forEach((langPack) => {
          let lang = Languages.find((val) => val.Item1 == langPack.languageCode);
          if (lang) {
            languages.push({ code: langPack.languageCode, codeName: lang.Item2, checked: true });
          }
        });

        stores.forEach((store) => {
          stwl.push({
            store: store.item1,
            storeDisplayName: store.item2,
            languages: languages,
            skuColumnName: store.skuColumnName
          });
        });

        skuColumnNames.forEach((skuCol) => {
          skuCol.isHidden = stwl.findIndex((val) => val.skuColumnName == skuCol.fieldName) < 0;
        });

        App.pageData('mpd_currenteditedcontent.masterProductData.storesWithLanguages', stwl);
        App.pageData('mpd_currenteditedcontent.masterProductData.skuColumnNames', skuColumnNames);
        App.pageData('selectDistChannels', []);
      }
    });
  };

  let downloadImageForAllFormat = (e) => {
    if (App.pageData('mpd_currenteditedcontent.masterProductData.archiveGeneratedFile')) {
      return;
    }

    UI.block('#MasterProductDataForm');
    let url = `MasterProductData/downloadAllFormat/${User.accountID()}/${$('#licensedId').val()}`;
    $.when(App.ajaxData(url, {}))
      .done((res) => {
        UI.notify({
          text: 'Files will be sent to your email',
          icon: 'fal fa-check-circle',
          type: 'success'
        });
      })
      .always((error) => {
        UI.unblock('#MasterProductDataForm');
      });
  };

  let downloadProdFile = (requestArray) => {
    let urls = [];
    let widths = [];
    let heights = [];
    let requests = '';

    requestArray.forEach((o, index) => {
      let spaceIndex = o.fileName.indexOf('_');
      let filenames = o.fileName.split('.');
      let fileName = o.fileName.substring(0, spaceIndex) + '.' + filenames[filenames.length - 1];
      o.width = Common.cmToInch(o.width);
      o.height = Common.cmToInch(o.height);

      requests += `requests[${index}].Url=${encodeURIComponent(o.url)}&requests[${index}].Widths=${
        o.width
      }&requests[${index}].Heights=${o.height}&requests[${index}].AreaType=${
        o.areaType
      }&requests[${index}].FileName=${fileName}&`;
    });
    console.log(requests);

    var src = `${$config.apiURL}/MasterProductData/download/${User.accountID()}/${
      window['DT'].data.id
    }/productionImages?${requests}`;
    var a = document.createElement('a');
    a.href = src;
    $(a).attr('download', true);
    a.click();
  };

  let downloadSkuCSV = () => {
    var csv = [];
    for (let i = 0; i < window.DT.mpd_currenteditedcontent.masterProductData.variants.length; i++) {
      let item = window.DT.mpd_currenteditedcontent.masterProductData.variants[i];
      var row = `${item.color},${item.sizes[0]},${item.sku}`;
      csv.push(row);
    }
    KTUtil.downloadCSV(csv.join('\n'), `${window.DT.mpd_currenteditedcontent.id}_variabts_sku.csv`);
  };

  let saveLangPack = (form) => {
    let currenteditedcontent = App.pageData('mpd_currenteditedcontent');

    var langPack = { languageCode: currenteditedcontent.defaults.currentLangCode, moduleType: 0, propertyValues: [] };
    if (!form) {
      form = generateFormData();
    }
    for (var prop in form) {
      let fields = _.filter(currenteditedcontent.masterProductData.translateFields, (item) => {
        return item.toUpperCase() == prop.toUpperCase();
      });
      if (fields && fields.length > 0) {
        var value = form[prop];
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            langPack.propertyValues.push({ fieldName: prop, value: value[i] });
          }
        } else {
          langPack.propertyValues.push({ fieldName: prop, value: value });
        }
      }
    }

    var newLangPack = [langPack];
    $.each(currenteditedcontent.masterProductData.availableLangPacks, (k, pack) => {
      if (pack.languageCode != currenteditedcontent.defaults.currentLangCode) {
        newLangPack.push(pack);
      }
    });

    App.pageData('mpd_currenteditedcontent.masterProductData.availableLangPacks', newLangPack);
  };

  let initCurrentLang = () => {
    let editedcontent = App.pageData('mpd_currenteditedcontent');
    let dataMPD = App.pageData();

    let currentLangPack = _.find(editedcontent.masterProductData.availableLangPacks, (item) => {
      return item.languageCode.toUpperCase() == editedcontent.defaults.currentLangCode.toUpperCase();
    });
    if (!currentLangPack || currentLangPack.propertyValues.length == 0) {
      for (var prop in dataMPD.data.masterProductData) {
        let fields = _.filter(editedcontent.masterProductData.translateFields, (item) => {
          return item.toUpperCase() == prop.toUpperCase();
        });
        if (fields && fields.length > 0) {
          var oldvalue = dataMPD.data.masterProductData[prop];
          if (Array.isArray(oldvalue)) {
            dataMPD.data.masterProductData[prop] = [];
          } else {
            dataMPD.data.masterProductData[prop] = '';
          }
        }
      }
    } else {
      var setfieldNames = [];
      for (var prop in dataMPD.data.masterProductData) {
        let fields = _.filter(currentLangPack.propertyValues, (item) => {
          return item.fieldName.toUpperCase() == prop.toUpperCase();
        });
        if (fields && fields.length > 0) {
          setfieldNames.push(fields[0].fieldName);
          var oldvalue = dataMPD.data.masterProductData[prop];
          if (Array.isArray(oldvalue)) {
            dataMPD.data.masterProductData[prop] = [];
            dataMPD.mpd_currenteditedcontent.masterProductData[prop] = [];

            for (let i = 0; i < fields.length; i++) {
              dataMPD.data.masterProductData[prop].push(fields[i].value);
              dataMPD.mpd_currenteditedcontent.masterProductData[prop].push(fields[i].value);
            }
          } else {
            dataMPD.data.masterProductData[prop] = fields[0].value;
            dataMPD.mpd_currenteditedcontent.masterProductData[prop] = fields[0].value;
          }
        }
      }

      let groupValue = [];
      for (let i = 0; i < currentLangPack.propertyValues.length; i++) {
        var currentValue = currentLangPack.propertyValues[i];
        let fields = _.filter(groupValue, (item) => {
          return item.fieldName.toUpperCase() == currentValue.fieldName.toUpperCase();
        });
        if (!fields || fields.length == 0) {
          groupValue.push({ fieldName: currentValue.fieldName, value: [currentValue.Value] });
        } else {
          fields[0].value.push(currentValue.value);
        }
      }

      for (let i = 0; i < groupValue.length; i++) {
        var currentValue = groupValue[i];
        let fields = _.filter(setfieldNames, (item) => {
          return item.toUpperCase() == currentValue.fieldName.toUpperCase();
        });
        if (!fields || fields.length == 0) {
          var valueName = currentValue.fieldName;
          var value = dataMPD.data.masterProductData[valueName];
          if (!value) {
            valueName = currentValue.fieldName.charAt(0).toLowerCase() + currentValue.fieldName.substring(1);
            value = dataMPD.data.masterProductData[valueName];
          }

          if (Array.isArray(value)) {
            dataMPD.data.masterProductData[valueName] = currentValue.value;
          } else {
            dataMPD.data.masterProductData[valueName] =
              currentValue.value.length > 1 ? currentValue.value : currentValue.value[0];
          }
        }
      }
    }
    dataMPD.mpdlocale =
      window['mpdlocale'][editedcontent.defaults.currentLangCode.toLowerCase()] || window['mpdlocale']['en'];

    let productionDataTab = mapping.productionData(dataMPD.data);

    let template = require('./tmpl/masterProductData.hbs');
    UI.page(template, dataMPD).then(() => {
      App.pageData('productionDataTab', productionDataTab);
      App.pageData('mpdlocale', dataMPD.mpdlocale);

      pageinit(dataMPD.data);
    });
  };

  let saveStore = (form) => {
    let currenteditedcontent = App.pageData('mpd_currenteditedcontent');

    const store = currenteditedcontent.masterProductData.storesWithLanguages.find((store) => store.store === currenteditedcontent.defaults.currentStore);

    if (!form) {
      form = generateFormData();
    }

    if (!store) {
      currenteditedcontent.masterProductData.masterRawData.productName = form.productName;
      currenteditedcontent.masterProductData.masterRawData.productDescription = form.productDescription;
      currenteditedcontent.masterProductData.masterRawData.bulletPoints = [...(form.bulletPoints || [])];
      currenteditedcontent.masterProductData.masterRawData.tags = [...(form.tags || [])];
    } else {
      store.productName = form.productName;
      store.productDescription = form.productDescription;
      store.bulletPoints = [...(form.bulletPoints || [])];
      store.tags = [...(form.tags || [])];
    }

    App.pageData('mpd_currenteditedcontent', currenteditedcontent);
  };

  let initCurrentStore = () => {
    let editedcontent = App.pageData('mpd_currenteditedcontent');
    let dataMPD = App.pageData();

    const store = editedcontent.masterProductData.storesWithLanguages.find((store) => store.store === editedcontent.defaults.currentStore);

    let storeDate;

    if (!store) {
      storeDate = {
        productName: editedcontent.masterProductData.masterRawData.productName,
        productDescription: editedcontent.masterProductData.masterRawData.productDescription,
        bulletPoints: [...(editedcontent.masterProductData.masterRawData.bulletPoints || [])],
        tags: [...(editedcontent.masterProductData.masterRawData.tags || [])],
      };
    } else {
      storeDate = {
        productName: store.productName,
        productDescription: store.productDescription,
        bulletPoints: [...(store.bulletPoints || [])],
        tags: [...(store.tags || [])],
      };
    }

    Object.assign(dataMPD.data.masterProductData, storeDate);
    Object.assign(dataMPD.mpd_currenteditedcontent.masterProductData, storeDate);

    // TODO set store locale
    dataMPD.mpdlocale = window['mpdlocale']['en'];

    let productionDataTab = mapping.productionData(dataMPD.data);

    let template = require('./tmpl/masterProductData.hbs');
    UI.page(template, dataMPD).then(() => {
      App.pageData('productionDataTab', productionDataTab);
      App.pageData('mpdlocale', dataMPD.mpdlocale);

      pageinit(dataMPD.data);
    });
  };

  let onSizesChanged = (e) => {
    e.preventDefault();
    let elem = $(e.target);
    let size = elem.val();
    let isHidden = !elem.prop('checked');

    let availableColors = App.pageData('mpd_currenteditedcontent.masterProductData.availableColors');
    let commerceDetails = App.pageData('mpd_currenteditedcontent.masterProductData.commerce.details');
    commerceDetails.forEach((detail) => {
      if (detail.size == size) {
        if (isHidden) {
          detail.isHidden = true;
        } else {
          if (availableColors.includes(detail.color)) {
            detail.isHidden = false;
          }
        }
      }
    });
    App.pageData('mpd_currenteditedcontent.masterProductData.commerce.details', commerceDetails);

    // Product Details
    let currenteditedcontent = App.pageData('mpd_currenteditedcontent');
    if (!currenteditedcontent.isAllOverPrint) {
      return;
    }

    let productDetails = App.pageData('mpd_currenteditedcontent.masterProductData.productDetails');
    productDetails.forEach((area) => {
      area.areaDetails.forEach((detail) => {
        if (detail.size !== size) {
          return;
        }

        if (!isHidden && !detail.imageFileUrl) {
          return;
        }

        detail.isHidden = isHidden;
      });
    });
    App.pageData('mpd_currenteditedcontent.masterProductData.productDetails', productDetails);

    // Set to compare
    App.pageData('mpd_currenteditedcontent.compares', MockupCompare.mapping.data(productDetails));
  };

  let onColorChanged = (e) => {
    let color = $(e)[0].name;
    let isHidden = !$(e)[0].checked;

    let commerceDetails = App.pageData('mpd_currenteditedcontent.masterProductData.commerce.details');
    if (
      isHidden &&
      commerceDetails.filter(function (obj) {
        return obj.color !== color && !obj.isHidden;
      }).length === 0
    ) {
      $(e).prop('checked', true);
      return;
    }

    // Available Colors
    let availableColors = App.pageData('mpd_currenteditedcontent.masterProductData.availableColors');
    availableColors = availableColors.filter((item) => item !== color);
    if (!isHidden) {
      availableColors.push(color);
    }
    App.pageData('mpd_currenteditedcontent.masterProductData.availableColors', availableColors);

    // Available Sizes & Commerce
    let availableSizes = App.pageData('mpd_currenteditedcontent.masterProductData.availableSizesWithCheckbox');
    availableSizes.forEach((size) => {
      if (size.checked) {
        commerceDetails.forEach((commerce) => {
          if (commerce.size === size.size && commerce.color === color) {
            commerce.isHidden = isHidden;
          }
        });
      }
    });
    App.pageData('mpd_currenteditedcontent.masterProductData.commerce.details', commerceDetails);

    // Product Details
    let currenteditedcontent = App.pageData('mpd_currenteditedcontent');
    if (currenteditedcontent.isAllOverPrint) {
      return;
    }

    let productDetails = App.pageData('mpd_currenteditedcontent.masterProductData.productDetails');
    productDetails.forEach((area) => {
      area.areaDetails.forEach((detail) => {
        if (detail.color !== color) {
          return;
        }

        if (!isHidden && !detail.imageFileUrl) {
          return;
        }

        detail.isHidden = isHidden;
      });
    });
    App.pageData('mpd_currenteditedcontent.masterProductData.productDetails', productDetails);

    // Set to compare
    App.pageData('mpd_currenteditedcontent.compares', MockupCompare.mapping.data(productDetails));
  };

  let originalFilesInit = () => {
    originalFilesDTbuild('OriginalFilesDataTable');
    originalFilesDTbuild('OriginalFilesDataTableProduction');

    $('.js-action-downloadOriginalfile')
      .off()
      .on('click', (e) => {
        const target = $(e.target).hasClass('js-action-downloadOriginalfile')
          ? $(e.target)
          : $(e.target).closest('.js-action-downloadOriginalfile');
        const filesurl = target.data('fileurl');
        if (!filesurl) return;
        downloadUrls(filesurl.split(','));
      });

    $('.js-action-DownloadMultipleFiles')
      .off()
      .on('click', (e) => {
        const target = $(e.target).hasClass('js-action-DownloadMultipleFiles')
          ? $(e.target)
          : $(e.target).closest('.js-action-DownloadMultipleFiles');
        const tableid = target.data('tableid');
        if (!tableid) return;
        let filesurl = [];
        let table = $(`#${tableid}`);
        $('input[name="originalfiles"][type="checkbox"]:checked', table).each(function () {
          filesurl = [...filesurl, ...$(this).data('fileuri').split(',')];
        });
        downloadUrls(filesurl);
      });
  };

  let originalFilesDTbuild = (tableId) => {
    let DataTable = $(`#${tableId}`).DataTable({
      serverSide: false,
      stateSave: false,
      responsive: false,
      cache: false,
      searching: false,
      columns: DataTableColumns.originalFiles,
      processing: false,
      paging: false,
      ordering: false,
      info: false,
      buttons: [],
      data: App.pageData('mpd_currenteditedcontent.masterProductData.originalFiles'),
      drawCallback: () => {
        UI.unblock('#page');
        // Image popup
        $(`#${tableId} .magnific-image`).magnificPopup({ type: 'image' });
      },
      initComplete: () => {
        $(`#${tableId} .details-control`).on('click', (e) => hadnleToggleMoreInfo(e, DataTable, `#${tableId}`));

        return;
        // Multiple Download Button
        $(`#${tableId} input[name="originalfiles"]`).on('change', () => {
          $(`button[data-tableid="${tableId}"]`).prop(
            'disabled',
            !$(`#${tableId} input[name="originalfiles"]:checked`).length
          );
        });
      }
    });
  };

  let originalFilesItemTemplate = (t, d) => {
    return `
      <li class="list-group-item custom-table-item">
        <div class="row flex-nowrap">
          <div class="col-4 custom-table-item-title">${t}</div>
          <div class="col-8">${d && d !== null ? d : ''}</div>
        </div>
      </li>`;
  };

  let originalFilesListTemplate = (item) => {
    let out = `
            <div class="row">
              <div class="col-sm-5">
                <p class="font-weight-bold text-muted">${$Lang.MasterProductData.OriginalFilesGroup.Columns.FileType}</p>
              </div>
              <div class="col-sm-7">
                <p class="font-weight-bold text-muted">${$Lang.MasterProductData.OriginalFilesGroup.Columns.FileName}</p>
              </div>
            </div>`;

    $.each(item.files, function (k, v) {
      out += `<div class="row">
                    <div class="col-sm-5">${v.type ? v.type : ''}</div>
                    <div class="col-sm-7 pb-2"><a href="javascript:" class="download-file-url" file-url="${v.uri}">${
        v.fileName
      }</a></div>
                  </div>`;
    });

    return out;
  };

  let originalFilesCommonTemplate = (item, commonHeader, commonColumns, descriptionHeader, filesHeader) => {
    return `
      <div class="custom-table-child-row">
        <div class="row">
          <div class="col-md-5">

            <div class="custom-table-header">${commonHeader}</div>

            <ul class="list-group">
                ${commonColumns.join('')}
            </ul>

            <div class="custom-table-header">${descriptionHeader}</div>

             <p>${item.asset.description}</p>

          </div>
          
          <div class="col-md-7">
            <div class="custom-table-header">${filesHeader}</div>
            
            ${originalFilesListTemplate(item)}
            
          </div>
        </div>
      </div>`;
  };

  let format = (item) => {
    if (item.assetType === 'Artwork')
      return originalFilesCommonTemplate(
        item,
        $Lang.MasterProductData.OriginalFilesGroup.Columns.ArtworkInfo,
        [
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.UploadedBy, item.assetOwner),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.SubBrand, item.asset.subBrand),
          originalFilesItemTemplate(
            $Lang.MasterProductData.OriginalFilesGroup.Columns.Collection,
            item.asset.collections.join(',')
          ),
          originalFilesItemTemplate(
            $Lang.MasterProductData.OriginalFilesGroup.Columns.ExternalId,
            item.asset.standartId
          )
        ],
        $Lang.MasterProductData.OriginalFilesGroup.Columns.ArtworkDescription,
        $Lang.MasterProductData.OriginalFilesGroup.Columns.ArtworkFiles
      );
    if (item.assetType === 'Blank')
      return originalFilesCommonTemplate(
        item,
        $Lang.MasterProductData.OriginalFilesGroup.Columns.BlankInfo,
        [
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Brand, item.assetOwner),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.BrandCode, item.asset.brandCode),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.Category, item.asset.category),
          originalFilesItemTemplate(
            $Lang.MasterProductData.OriginalFilesGroup.Columns.SubCategory,
            item.asset.subCategory
          ),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.Style, item.asset.comments),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.Line, item.asset.line),
          originalFilesItemTemplate(
            $Lang.MasterProductData.OriginalFilesGroup.Columns.Colors,
            DT.mpd_currenteditedcontent.masterProductData.availableColors.join(', ')
          ),
          originalFilesItemTemplate(
            $Lang.MasterProductData.OriginalFilesGroup.Columns.Sizes,
            DT.mpd_currenteditedcontent.masterProductData.availableSizes.join(', ')
          ),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.BlankCost, '')
        ],
        $Lang.MasterProductData.OriginalFilesGroup.Columns.BlankDescription,
        $Lang.MasterProductData.OriginalFilesGroup.Columns.BlankFiles
      );
    if (item.assetType === 'Trim')
      return originalFilesCommonTemplate(
        item,
        $Lang.MasterProductData.OriginalFilesGroup.Columns.TrimInfo,
        [
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.UploadedBy, item.assetOwner),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.TrimType, item.asset.trimType),
          originalFilesItemTemplate(
            $Lang.MasterProductData.OriginalFilesGroup.Columns.LabelSize,
            item.asset.labelSize.width +
              ' x ' +
              item.asset.labelSize.height +
              ' ' +
              item.asset.labelSize.measurementUnit
          ),
          originalFilesItemTemplate(
            $Lang.MasterProductData.OriginalFilesGroup.Columns.DedicatedLocation,
            item.asset.dedicatedLocation
          ),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.Comments, item.asset.comments)
        ],
        $Lang.MasterProductData.OriginalFilesGroup.Columns.TrimDescription,
        $Lang.MasterProductData.OriginalFilesGroup.Columns.TrimFiles
      );
    if (item.assetType === 'Stamp')
      return originalFilesCommonTemplate(
        item,
        $Lang.MasterProductData.OriginalFilesGroup.Columns.StampInfo,
        [
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.UploadedBy, item.assetOwner),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.Brand, item.asset.brand),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.SubBrand, item.asset.subBrand),
          originalFilesItemTemplate($Lang.MasterProductData.OriginalFilesGroup.Columns.Comments, item.asset.comments)
        ],
        $Lang.MasterProductData.OriginalFilesGroup.Columns.StampDescription,
        $Lang.MasterProductData.OriginalFilesGroup.Columns.StampFiles
      );
  };

  let hadnleToggleMoreInfo = (e, dataTbl, tableAttribute) => {
    let table = $(tableAttribute);
    table.css({ 'border-collapse': 'separate' });
    let tr = $(e.target).closest('tr');
    let row = dataTbl.row(tr);
    if (row.child.isShown()) {
      tr.removeClass('details');
      row.child.hide();
    } else {
      console.log(row.data());
      tr.addClass('details');
      row.child(format(row.data())).show();
    }
  };

  let downloadUrls = (fileUris) => {
    if (!fileUris || fileUris.length === 0) return;
    let url = `${$config.apiURL}/MasterProductData/downloadfiles/?`;
    fileUris.forEach((val, index, list) => {
      let append = index !== list.length - 1 ? '&' : '';
      url += 'files=' + encodeURIComponent(val) + append;
    });
    let a = document.createElement('a');
    a.href = url;
    a.download = true;
    a.click();
  };

  return {
    init,
    productFormSubmit,
    downloadSkuCSV,
  };
})();
